<template>
    <th :style="{ textAlign: column.align, whiteSpace: 'nowrap' }" :class="[column.class, { sortable: column.sortable, 'sortable-active': order.column === column.id }]">
        {{column.label}}
        <alzata-sort-indicator :order="order" :columnId="column.id" />
    </th>
</template>

<script>
export default {
    name: 'AlzataTableColumnHeader',
    props: {
        column: {},
        order: {},
    },
};
</script>